import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, useParams } from 'react-router-dom'
import { AppContext } from '../../../global'
import { Filter } from '../../subscriptions/store/store'
import slugify from 'react-slugify'
import './QuickLinks.css'
import PanelWithHeader from '../../../components/panels/PanelWithHeader'
import { RequestState } from '../../types'
import { Params } from '../../types'

function QuickLinks() {
  const { state } = useContext(AppContext)
  const history = useHistory()
  const filtersState = state.filters
  const { partnerId } = useParams() as Params
  const { t } = useTranslation(['dashboard'])

  return (
    <PanelWithHeader id="quick-links" title={t('subscription_filters.title')}>
      {filtersState.requestState === RequestState.Loading && (
        <div id="loading" className="panel-message-body">
          <i className="fas fa-spinner fa-spin font-size-xl"></i>
          <br />
        </div>
      )}

      {filtersState.requestState !== RequestState.Loading && filtersState.filters.length === 0 && (
        <div className="panel-message-body">{t('subscription_filters.no_filters')}</div>
      )}

      {filtersState.requestState !== RequestState.Loading && filtersState.filters.length > 0 && (
        <div id="quick-links-content">
          {filtersState.filters.map((filter: Filter) => (
            <div
              id={slugify(filter.name)}
              key={filter.id}
              className="panel-item"
              onClick={() => history.push(`/partner/${partnerId}/subscriptions?filter=${filter.id}`)}>
              <div className="flex-justify">
                <div>{filter.name}</div>
                <div className={'filter-profile-' + filter.profile}>{filter.subscription_count}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </PanelWithHeader>
  )
}

export default QuickLinks
